import { useTranslation } from 'react-i18next';

import { ALL_ATE_AGENCY_IDS } from '@ngsos/portal-core/agency';

import { DataPanel, DataPanelInlineItem, AgencyView } from '@/ui';
import { CallSignPanelItem } from './CallSignPanelItem';

export type AdditionalDataSectionProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  callSign: string | null;
  ateMessage: string | null;
};

export function AdditionalDataSection({
  incidentId,
  incidentIsReadOnly,
  callSign,
  ateMessage,
}: AdditionalDataSectionProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_AdditionalIncidentData_PanelHeader')}>
      <CallSignPanelItem incidentId={incidentId} callSign={callSign} incidentIsReadOnly={incidentIsReadOnly} />

      {ateMessage != null && ateMessage.trim() !== '' && (
        <AgencyView agencyIds={ALL_ATE_AGENCY_IDS}>
          <DataPanelInlineItem
            title={t('Incident_InfoPanel_AteMessage')}
            value={ateMessage}
            editable={false}
            showEmptyPlaceholder
          />
        </AgencyView>
      )}
    </DataPanel>
  );
}
